import { classNames } from 'primereact/utils';

interface ChatDisclaimerProps {
  className?: string;
}

export const ChatDisclaimer = ({ className }: ChatDisclaimerProps) => {
  return (
    <div
      className={classNames(
        'text-theme-text-grey w-full text-center text-[0.625rem] @[23.75rem]:text-[0.75rem]',
        className,
      )}
    >
      Fletch can make mistakes so it's important to check results.
    </div>
  );
};
